<div class="vsf-modal-dialog">
    <header class="vsf-modal-dialog__header">
        <h2 class="vsf-modal-dialog__title">
            <ng-container *ngIf="titleTemplateRef" [ngTemplateOutlet]="titleTemplateRef"></ng-container>
        </h2>
        <button
            *ngIf="options?.closable"
            type="button"
            class="vsf-modal-dialog__close"
            (click)="closeModal()"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
    </header>
    <div class="vsf-modal-dialog__body">
        <vsf-dialog-component-outlet
            [component]="childComponentType"
            (create)="onCreate($event)"
        ></vsf-dialog-component-outlet>
    </div>
    <footer class="vsf-modal-dialog__footer" *ngIf="buttonsTemplateRef">
        <ng-container [ngTemplateOutlet]="buttonsTemplateRef"></ng-container>
    </footer>
</div>
